import type {
  GridOptions,
  IRowNode,
  PostProcessPopupParams,
  RowClassParams,
} from 'ag-grid-community';

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  valueCache: true,
  animateRows: true,
  enableCellChangeFlash: true,
  suppressRowClickSelection: true,
  suppressRowDeselection: true,
  rowSelection: 'multiple',
  rowModelType: 'serverSide',
  cacheBlockSize: 100,
  maxConcurrentDatasourceRequests: 2,
  infiniteInitialRowCount: 10,
  maxBlocksInCache: 3,
  rowBuffer: 10,
  blockLoadDebounceMillis: 100,
  suppressScrollOnNewData: true,
  suppressCellFocus: true,
  suppressContextMenu: true,
  suppressFocusAfterRefresh: true,
  suppressMaintainUnsortedOrder: true,
  suppressDragLeaveHidesColumns: true,
  groupDisplayType: 'custom',
  excludeChildrenWhenTreeDataFiltering: true,
  debounceVerticalScrollbar: true,
  suppressMaxRenderedRowRestriction: true,
  getRowId: (d) => (d.data.taskId as number | string).toString(),
  getDataPath: (d) => [(d.taskId as number | string).toString()],
  getServerSideGroupKey: (d) => (d.taskId as number | string).toString(),
  isRowSelectable: (node: IRowNode) => node.id !== 'provisional',
  rowClassRules: {
    'task-grid-row-private': ({ data }: RowClassParams) => data?.private,
  },
  postProcessPopup: ({ ePopup, column, rowNode }: PostProcessPopupParams) => {
    if (column?.getId() !== 'status' || rowNode?.id !== 'provisional') {
      return;
    }

    ePopup.style.border = '2px solid var(--blue-60)';
    ePopup.style.borderRadius = '0';
  },
  defaultColDef: {
    resizable: true,
    sortable: true,
    unSortIcon: true,
    editable: false,
    lockPinned: true,
    suppressMovable: true,
    suppressMenu: true,
    cellEditorPopup: true,
    cellEditorPopupPosition: 'over',
  },
  isServerSideGroupOpenByDefault: () => false,
  autoGroupColumnDef: {
    field: 'task',
    hide: true,
  },
};
